import { defaultLanguageKey } from 'Utility/SDK/Language';
import PIXIResource from 'Utility/Resource/PIXIResource';
import PIXIRenderer from 'System/Render/PIXIRenderer';
import FBSDKDriver from 'Utility/SDK/Drivers/FBSDKDriver';
import Environment from 'Utility/Environment';
import { IGameConfig } from 'Utility/IGameConfig';
import { isOSBelowVersion, Platform } from 'Utility/Platform';
import { IGameConfigSettings } from 'Utility/IGameConfigSettings';

declare const __VERSION__: string;
declare const __RELEASE__: string;
declare const __SETTINGS__: IGameConfigSettings;

export async function getGameConfig(): Promise<IGameConfig> {
    // TODO: This probably doesn't belong here.
    //const FB_TRACKING_ID = 'fbTracking';
   /* if (process?.env.NODE_ENV === Environment.PRODUCTION) {
        // Only load facebook pixel tracking on Facebook production builds
        const fbTracking = (document.getElementById(FB_TRACKING_ID) as HTMLTemplateElement).content.cloneNode(true);
        document.body.appendChild(fbTracking);
    }*/

    return {
        appId: __SETTINGS__.appId,
        gameID: __SETTINGS__.gameID,
        version: __VERSION__,
        release: __RELEASE__,
        DDNA_URL: __SETTINGS__.DDNA_URL,
        DDNA_KEY: __SETTINGS__.DDNA_KEY,
        adInterstitialDefaultID: __SETTINGS__.adInterstitialDefaultID,
        adRewardedNoCoinsID: __SETTINGS__.adRewardedNoCoinsID,
        adRewardedWatchToPlayID: __SETTINGS__.adRewardedWatchToPlayID,
        adRewardedDoubleHarvestID: __SETTINGS__.adRewardedDoubleHarvestID,
        DDNA_EventSendInterval: 15000,
        language: defaultLanguageKey,
        resourceDriver: PIXIResource,
        renderer: PIXIRenderer,
        fpsLimit: isOSBelowVersion('Android', 8) || isOSBelowVersion('iOS', 12) ? 30 : 60,
        dataSaveIntervalMS: 1500,
        forceCanvas: isOSBelowVersion('Android', 4.4),
        levelBasePath: 'resource/data/levels',
        shareImageFormat: 'image/jpeg',
        shareImageQuality: 0.85,
        SDKDriver: FBSDKDriver,
        platform: Platform.FACEBOOK,
    };
}
